export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';
export const COMMON_NOTIFICATION = 'COMMON_NOTIFICATION';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const SET_MODAL_BUTTON_LOADING = "SET_MODAL_BUTTON_LOADING";
export const SHOW_LOADER = "SHOW_LOADER";
export const HIDE_LOADER = "HIDE_LOADER";

